@if(show) {
	<div class="update-wrapper">
		@if(update) {
			<span (click)="openUpdater()" class="phb-icon icon--update" [title]="'title_update' | translate:systemLanguage"></span>
		}
	</div>
}

